import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../Components/Layout/Navbar';

import Sidebar from '../Components/Layout/SideBar';

const Layout = () => {
	return (
		<div className=''>
			<Sidebar />
			<div className='w-full'>
				<Navbar />
				<main className='flex justify-center items-center py-10 '>
					<Outlet />
				</main>
			</div>
		</div>
	);
};

export default Layout;
